import React, { Component } from 'react';
import Analytics from 'react-ga';
import LocationMap from './LocationMap';
import config from '../../../config';
import facebookIcon from '../../../shared-assets/facebook-icon.svg';
import youtubeIcon from '../../../shared-assets/youtube-icon.svg';
import './styles.css';

export default class HoursAndLocation extends Component {

  componentDidMount() {

    Analytics.pageview('/hours');
  }

  render() {
    return (
      <div className="hours-and-location">
        <div className="store-info-table">
          <div className="store-info-table-section">
            <div className="hours-table">
              <div className="hours-group">
                <div className="hours-name">
                  Mon - Fri:
                </div>
                <div className="hours">
                  10 am - 6 pm
                </div>
              </div>

              <div className="hours-group">
                <div className="hours-name">
                  Sat:
                </div>
                <div className="hours">
                  10 am - 5 pm
                </div>
              </div>

              <div className="hours-group">
                <div className="hours-name">
                  Sun:
                </div>
                <div className="hours hours-closed">
                  Closed
                </div>
              </div>
            </div>
          </div>
          <div className="store-info-table-section">
            <a href="tel:765-474-2942">(765)474-2942</a>
          </div>
          <div className="store-info-table-section">
            mcguiremusic@frontier.com
          </div>
          <div className="store-info-table-section">
            11 Sagamore Parkway S.
            <br/>
            Lafayette, IN 47905
          </div>
          <div className="store-info-table-section">
            <a href="https://www.facebook.com/McGuireMusicandSound" target="_blank">
              <img src={facebookIcon} alt="FaceBook"/>
            </a>
            <a href="https://www.youtube.com/channel/UCO-246Ku3knZOatyneXT_4g" target="_blank">
              <img src={youtubeIcon} alt="YouTube"/>
            </a>
          </div>
        </div>
        <div className="location-map">
          <LocationMap googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&key=${config.GOOGLE_MAPS_API_KEY}&libraries=geometry,drawing,places`}
                       loadingElement={<div style={{ height: '100%', width: '100%' }} />}
                       containerElement={<div style={{ height: '100%', width: '100%' }} />}
                       mapElement={<div style={{ height: '100%', width: '100%' }} />}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StoreInfoPage/HoursAndLocation/index.js